import { render } from "./Footer.vue?vue&type=template&id=73cb8bd9&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=73cb8bd9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73cb8bd9"

export default script